import './lib/polyfills';
import lazySizes from './lib/lazysizes';
import $ from '@vaersaagod/tools/Dom';
import Viewport from '@vaersaagod/tools/Viewport';
import Components from '@vaersaagod/tools/Components';
import colorchanger from './modules/colorchanger';
import parallaxer from './modules/Parallaxer';
import ViewportHeight from './components/ViewportHeight';

import 'gsap';
import 'gsap/ScrollToPlugin';


/*
*   Bootstrap app
*
 */
const init = () => {
    Viewport.init();
    Viewport.releaseTabbing();
    Components.init();
    lazySizes.init();
    parallaxer.init();
    
    colorchanger();

    const $body = $('body');
    
    $body.on('click', '[data-scroll-to-anchor]', (e) => {
        e.preventDefault();
        const $trigger = $(e.triggerTarget);
        
        if ($trigger.length > 0) {
            const targetHref = $trigger.attr('href');
            const $target = $(targetHref);
    
            if ($target.length > 0) {
                TweenLite.to(window, 1.1, { scrollTo: $target.offset().top, ease: Quint.easeInOut });
            }
        }
    });
    
    $body.on('click', '[data-scroll-to-location-link]', (e) => {
        e.preventDefault();
        const $target = $body.find('[data-interactivemap]');
        console.log($target);
        if ($target.length > 0) {
            TweenLite.to(window, 1.1, { scrollTo: $target.offset().top, ease: Quint.easeInOut });
        }
    });
    
    $body.find('a[data-will-have-skew], .wysiwyg a').each(el => {
        const $link = $(el);
        if ($link.find('.u-skew-link').length === 0) {
            $link.html('<span class="d-ib u-skew-link">' + $link.text() + '</span>');
        }
    });

    $body.on('click', '.default-image', e => {
        if ($('html').hasClass('using-mouse')) {
            return true;
        }
        e.preventDefault();
        e.stopPropagation();
        return false;
    });
    
    
};

require('doc-ready')(() => {
    if (ENV === 'production') {
        init();
    } else {
        // Dev mode; check for styles before booting
        // Don't worry chief – this code will be stripped out of your production build <3
        const checkCSS = () => {
            if (getComputedStyle(document.body).boxSizing !== 'border-box') {
                requestAnimationFrame(checkCSS);
                return;
            }
            init();
        };
        checkCSS();
    }
});



// WEBPACK FOOTER //
// ./src/js/main.js